import { render, staticRenderFns } from "./suppliers-new.vue?vue&type=template&id=7a25410a&scoped=true"
import script from "./suppliers-new.vue?vue&type=script&lang=js"
export * from "./suppliers-new.vue?vue&type=script&lang=js"
import style0 from "./suppliers-new.vue?vue&type=style&index=0&id=7a25410a&prod&lang=css"
import style1 from "./suppliers-new.vue?vue&type=style&index=1&id=7a25410a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a25410a",
  null
  
)

export default component.exports